(function() {
    'use strict';

    const btnsNavToggle = document.querySelectorAll('.js-navMobileToggle');

    function toggleNav() {
        document.body.classList.toggle('body--mobNavOpen');
        document.getElementById(this.dataset.target).classList.toggle('mobNavOpen');
    }

    btnsNavToggle.forEach((elm) => {
        elm.addEventListener('click', toggleNav);
    });
})();